import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import { addCountry } from "store/actions";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import ImageUpload from "components/shared/ImageUpload";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";

const AddCountry = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { formatMessage, locale } = useIntl();

  const [selectedAppLogo, setSelectedAppLogo] = useState({
    preview: null,
    path: "",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    if (!selectedAppLogo?.path) {
      toastErrorMessage(formatMessage({ id: "imageErrorMessage" }), locale);
      return;
    }
    data.image = `/uploads/${selectedAppLogo?.path?.split("/").at(-1)}`;

    dispatch(addCountry({ data, navigate }));
  };

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>اضف دولة جديدة</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col lg={12} xs={12}>
                  <div className="form-group required">
                    <h5>علم الدولة</h5>
                    <ImageUpload
                      selectedImage={selectedAppLogo}
                      setSelectedImage={setSelectedAppLogo}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={6} xs={12}>
                  <div className="form-group required">
                    <h5>اسم الدولة بالعربية</h5>
                    <div>
                      <input
                        type="text"
                        className="form-control form-outline"
                        placeholder="اسم الدولة"
                        {...register("name.ar", { required: true })}
                      />
                    </div>
                    <p className="error-hint">
                      {errors?.name?.ar?.type === "required" &&
                        "يرجي ادخال اسم الدولة"}
                    </p>
                  </div>
                </Col>
                <Col lg={6} xs={12}>
                  <div className="form-group required">
                    <h5>اسم الدولة بالانجليزية</h5>
                    <div>
                      <input
                        type="text"
                        className="form-control form-outline"
                        placeholder="اسم الدولة"
                        {...register("name.en", { required: true })}
                      />
                    </div>
                    <p className="error-hint">
                      {errors?.name?.en?.type === "required" &&
                        "يرجي ادخال اسم الدولة"}
                    </p>
                  </div>
                </Col>
                <Col lg={6} xs={12}>
                  <div className="form-group">
                    <h5> عنوان نصي بالعربية</h5>
                    <div>
                      <input
                        type="text"
                        className="form-control form-outline"
                        placeholder="عنوان نصي"
                        {...register("title.ar")}
                      />
                    </div>
                  </div>
                </Col>
                <Col lg={6} xs={12}>
                  <div className="form-group">
                    <h5> عنوان نصي بالانجليزية</h5>
                    <div>
                      <input
                        type="text"
                        className="form-control form-outline"
                        placeholder="عنوان نصي"
                        {...register("title.en")}
                      />
                    </div>
                  </div>
                </Col>
                <Col lg={6} xs={12}>
                  <div className="form-group">
                    <h5> وصف نصي بالانجليزية</h5>
                    <div>
                      <textarea
                        className="form-control form-outline"
                        placeholder="وصف نصي"
                        {...register("description.ar")}
                      />
                    </div>
                  </div>
                </Col>
                <Col lg={6} xs={12}>
                  <div className="form-group">
                    <h5> وصف نصي بالانجليزية</h5>
                    <div>
                      <textarea
                        className="form-control form-outline"
                        placeholder="وصف نصي"
                        {...register("description.en")}
                      />
                    </div>
                  </div>
                </Col>

                <div className="seo-data">
                  <h3 className="mb-3">بيانات السيو</h3>
                  <Row>
                    <Col lg={6} xs={12}>
                      <div className="form-group  ">
                        <h5>عنوان (meta title) بالعربية</h5>
                        <div>
                          <input
                            type="text"
                            className="form-control form-outline"
                            {...register("metaTitle.ar")}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col lg={6} xs={12}>
                      <div className="form-group  ">
                        <h5>عنوان (meta title) بالانجليزية</h5>
                        <div>
                          <input
                            type="text"
                            className="form-control form-outline"
                            {...register("metaTitle.en")}
                            dir="ltr"
                          />
                        </div>
                      </div>
                    </Col>
                    <Col lg={6} xs={12}>
                      <div className="form-group  ">
                        <h5>وصف (meta description) بالعربية</h5>
                        <div>
                          <textarea
                            className="form-control form-outline"
                            {...register("metaDescription.ar")}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col lg={6} xs={12}>
                      <div className="form-group  ">
                        <h5>وصف (meta description) بالانجليزية</h5>
                        <div>
                          <textarea
                            className="form-control form-outline"
                            {...register("metaDescription.en")}
                            dir="ltr"
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>

                <Col lg={4} xs={12}>
                  <div className="form-group mt-3">
                    <button type="submit" className="btn btn-blue">
                      اضافة الدولة
                    </button>
                  </div>
                </Col>
              </Row>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCountry;
